// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function column24_mouseIn(event) {
	$w('#text1').show()
	$w('#Box1').show();
}

export function column24_mouseOut(event) {
	$w('#text1').hide()
	$w('#Box1').hide();
}

export function column25_mouseIn(event) {
	$w('#text2').show()
	$w('#Box2').show();

}

export function column25_mouseOut(event) {
	$w('#text2').hide()
	$w('#Box2').hide();
} 


export function column26_mouseIn(event) {
	$w('#text3').show()
	$w('#Box3').show();
}

export function column26_mouseOut(event) {
	$w('#text3').hide()
	$w('#Box3').hide();
}

export function column28_mouseIn(event) {
	$w('#text4').show()
	$w('#Box4').show();
}


export function column28_mouseOut(event) {
	$w('#text4').hide()
	$w('#Box4').hide();
}



